import useScrollListener from '../../hooks/useScrollListener';

import HeaderImage from "../../components/header-image/header-image.component";
import MultiImagesDisplay from "../../components/multi-images-display/multi-images-display.component";
import ContentBox from "../../components/content-box/content-box.component";
import ImageContentBox from "../../components/image-content-box/image-content-box.component";
import TextAndImage from "../../components/text-and-image/text-and-image.component";

import { 
	BlogRouteContainer, 
	BlogContainer
 } from "./service-page.styles";


const ServicePage = ({
	onScroll,
    headerImage,
	multiDisplay1,
	contentBox,
	imageContent1,
	imageContent2,
	textAndImage1,
	textAndImage2
}) => {

	const contentRef = useScrollListener(onScroll);

	return(
		<BlogRouteContainer ref={contentRef}>
			<BlogContainer 
				
				theme={{ hoverBg: 'white', hoverBrd: 'black' }}
			>
				<div className="head-tripple-box">
				<HeaderImage 
						img={headerImage.img} 
						title={headerImage.title}
						subtitle={headerImage.subtitle}
						buttonText={headerImage.buttonText}
					/>
					<MultiImagesDisplay 
						displays={multiDisplay1}
					/>
				</div>
				<ContentBox 
					title={contentBox.title} 
					text={contentBox.text}
					buttonLink={contentBox.buttonLink}
					buttonText={contentBox.buttonText}
				/>
				<ImageContentBox 
					img={imageContent1.image} 
					title={imageContent1.title}
					text={imageContent1.text}
				/>
				<TextAndImage 
					img={textAndImage1.img} 
					title={textAndImage1.title} 
					text={textAndImage1.text}
					txtL={textAndImage1.txtL}
				/>
				<TextAndImage 
					img={textAndImage2.img} 
					title={textAndImage2.title} 
					text={textAndImage2.text}
					txtL={textAndImage2.txtL}
				/>
				<ImageContentBox 
					img={imageContent2.image} 
					title={imageContent2.title}
					text={imageContent2.text} 
					buttonText={imageContent2.buttonText}
					buttonLink={imageContent2.buttonLink}
				/>
			</BlogContainer>
		</BlogRouteContainer>
	);
}

export default ServicePage;